import React from "react";
// import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {withRouter} from "react-router";
import axios from "axios";
import qs from "qs";
import moment from "moment";
import {
    BASE_URL,
    DOWNLOAD_DOCUMENT,
    DOWNLOAD_DOCUMENT_BY_REQUEST_AND_ZIP, MD,
    SM,
    XS
} from "../../constants/constants";
import {
    API_SHARE_DOCUMENTS_BY_TOKEN,
    PAGE_DOWNLOAD_REQUEST_DOCUMENT
} from "../../constants/apiSuffix";
import NavBar2 from "../NavBar2";
import TextBox from 'devextreme-react/text-box';
import banner from "../../images/banner/banner.png";
import notify from 'devextreme/ui/notify';
import DataGrid, {Column,Button} from 'devextreme-react/data-grid';
import { Button as Button2 } from 'devextreme-react/button';
import GeneralModal from "../../theme/Modal/GeneralModal";
import ContentPreviewModal2 from "../../theme/Modal/ContentPreviewModal2";
import {ConvertToDateD_M_Y, convertToDateH_m} from "../../functions/datetime";

const styles = theme => ({
    headerLogo: {
        height: "80px",
        display: "flex",
        padding: "0 4rem",
        background: "#fff",
        alignItems: "center",
        justifyContent: "space-between",
        [theme.breakpoints.down(SM)]:{
            padding: "0 1.5rem",
        },
        '& h1':{
            [theme.breakpoints.down(SM)]:{
                fontSize: 20,
                lineHeight: 1.3,
                paddingLeft: 8,
                width: 'min-content'
            },
        }
    },
    headerShare: {
        background: `url(${banner})`,
        backgroundSize: 'cover',
        height: 50,
        position: 'relative',
        '&::before':{
            content:'""',
            width: '55%',
            height: '100%',
            position: 'absolute',
            background: 'linear-gradient(270deg, rgba(14, 56, 96, 0) 8.24%, #0E2F60 34.94%, #0A0730 97.58%)',
        },
        // [theme.breakpoints.down(XS)]:{
        //     height: '200px!important'
        // },
        // [theme.breakpoints.between(XS, SM)]: {
        //     height: '175px'
        // },
    },
    shareDocumentsContainer: {
        width: "90vw",
        margin: "auto",
        textAlign: "center",
        marginTop: "25px",
        '& .inputForm': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        "& .inputPassword": {
            maxWidth: '80%',
            width: 480,
        },
        '& .btnOk': {
            color: '#4040ff',
            backgroundColor: '#dbedff7d',
            height: 36,
            minWidth: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 5,
            borderRadius: 4,
            cursor: 'pointer'
        }
    },
    downloadAll: {
        textTransform: 'uppercase',
        marginTop: '10px',
        float: 'right'
    }
});

axios.defaults.baseURL = BASE_URL;
axios.defaults.headers.common['timezone'] = moment().utcOffset()

class ReadShareDocuments extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: "",
            downloadVisible: false,
            shareDocs: {
                files: [],
                token: "",
                validityDate: "",
            },
            fileView: null
        }

        this.getShareDocuments = this.getShareDocuments.bind(this)
        this.initShareDocs = this.initShareDocs.bind(this)
        this.onPasswordChange = this.onPasswordChange.bind(this)
        this.downloadFile = this.downloadFile.bind(this)
        this.downloadAllFiles = this.downloadAllFiles.bind(this)

        // this.getShareDocuments().then(response => {
        //     console.log("RESPONSE",response)
        // })
    }

    onPasswordChange(event) {
        this.setState({
            password: event.value,
        })
        // if (event.previousValue === '' && event.value !== '') {
        //     this.setState({
        //         password: event.value,
        //     })
        //     this.getShareDocuments()
        // }
    }

    initShareDocs() {
        this.setState({
            password: "",
            shareDocs: {
                files: [],
                token: "",
                validityDate: "",
            }
        })
    }

    handleCloseModal = () => {
        this.setState({
            fileView: null
        })
    }

    getShareDocuments() {
        console.log("PROPS",this.props)
        console.log("TOKEN",this.props.match.params.token)

        const formData = new FormData();
        formData.append("password",this.state.password)

        this.initShareDocs()

        const token = this.props.match.params.token
        return axios.post(API_SHARE_DOCUMENTS_BY_TOKEN.replace("{token}", token),formData)
            .then(response => {
                if (response.data.success) {
                    this.setState({
                        downloadVisible: true,
                        shareDocs: {
                            ...response.data.data,
                            files: response.data.data.files.map(item => {
                                if (item.isMeetingVideo) {
                                    const docName = this.props.t('requestDocument.label.videoCallName', {
                                        date: ConvertToDateD_M_Y(item.createdAt),
                                        time: convertToDateH_m(item.createdAt)
                                    });
                                    return {
                                        ...item,
                                        originalFileName: docName,
                                    }
                                }
                                return item;
                            })
                        }
                    })
                }
                else if(response.data.message) notify(response.data.message,"error",5000)
                else notify("Mot de passe incorrect","error",2000)
                // console.log("GET RESPONSE:",response.data)
                // return response.data.success ? response.data.data : null
            })
    }

    downloadFile(cellData) {
        console.log("call downloadFile",cellData)
        // return `${window.location.protocol}//${window.location.host}`
        const params = {
            documentId: cellData.row.data.id,
            typeDownload: DOWNLOAD_DOCUMENT,
            downloadToken: this.state.shareDocs.token
        }

        // window.location = `${BASE_URL}${PAGE_DOWNLOAD_REQUEST_DOCUMENT}?${qs.stringify(params)}`;

        const link = document.createElement('a');
        link.href = `${BASE_URL}${PAGE_DOWNLOAD_REQUEST_DOCUMENT}?${qs.stringify(params)}`;
        link.setAttribute('download', cellData.row.data.fileName); //or any other extension
        document.body.appendChild(link);
        link.click();

        // return axios
        //             .get(`${PAGE_DOWNLOAD_REQUEST_DOCUMENT}?${qs.stringify(params)}`)
        //             .then((response) => {
        //                 const url = window.URL.createObjectURL(new Blob([response.data]));
        //                 const link = document.createElement('a');
        //                 link.href = url;
        //                 link.setAttribute('download', cellData.row.data.fileName); //or any other extension
        //                 document.body.appendChild(link);
        //                 link.click();
        //             })
        //             .catch(err => {
        //                 notify("Problème lors du téléchargement du fichier. Veuillez contacter l'équipe BLICKO","error",2000)
        //             });
    }

    viewFile = (cellData) => {
        this.setState({
            fileView: cellData.row.data
        })
    }

    downloadAllFiles() {
        console.log("call downloadAllFiles")
        // return `${window.location.protocol}//${window.location.host}`
        const params = {
            typeDownload: DOWNLOAD_DOCUMENT_BY_REQUEST_AND_ZIP,
            downloadToken: this.state.shareDocs.token
        }

        window.location = `${BASE_URL}${PAGE_DOWNLOAD_REQUEST_DOCUMENT}?${qs.stringify(params)}`;
    }

    render() {
        const {classes,t} = this.props;
        const {
            fileView,
        } = this.state;
        // const files = this.state.shareDocs.files.map(file => {
        //     let retFile = {
        //         fileName: file.fileName,
        //         url: file.id
        //     }
        //     return retFile
        // });

        const {files} = this.state.shareDocs
        // console.log(files)
        return (
            <div className={classes.main}>
                <div className={classes.headerLogo}>
                    <a aria-current="page" className="active" href="/">
                        <img src="data:image/png;base64,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" alt="logo" />
                    </a>
                    <h1>{t("text.doc_share_space")}</h1>
                </div>
                <div className={classes.headerShare}>
                    <NavBar2 noReturn={true}/>
                </div>
                <div className={classes.shareDocumentsContainer}>
                    {!this.state.downloadVisible ? <div>
                        <h2>{t("text.share_description")} :</h2>
                        <div className="inputForm">
                            <TextBox
                                className={"inputPassword"}
                                name="downloadPassword"
                                mode="password"
                                value={this.state.password}
                                onValueChanged={this.onPasswordChange}
                                onKeyUp={(value) => {
                                    if (value?.event?.key === 'Enter') {
                                        this.getShareDocuments();
                                    }
                                }}
                                placeholder={t("text.share_password_placeholder")}
                            />
                            <div className="btnOk" onClick={() => {
                                this.getShareDocuments();
                            }}>
                                {t("button.ok")}
                            </div>
                        </div>
                    </div> : ""}
                    {this.state.downloadVisible && this.state.shareDocs.files.length > 0 ? <>
                        <DataGrid
                            dataSource={files}
                        >
                            <Column dataField="originalFileName" />
                            {/* <Column dataField="type" /> */}
                            {/* <Column dataField="fileName" /> */}
                            <Column caption="Actions" type="buttons">
                                <Button
                                    name="download"
                                    text={t("button.download")}
                                    onClick={this.downloadFile}
                                />
                                <Button
                                    name="view"
                                    text={t("button.see")}
                                    onClick={this.viewFile}
                                />
                            </Column>
                        </DataGrid>

                        <Button2
                            className={classes.downloadAll}
                            name="downloadAll"
                            type="default"
                            icon="download"
                            text={t("button.download_all")}
                            onClick={this.downloadAllFiles}
                        />
                    </> : "" }
                </div>
                {fileView && <GeneralModal
                    className={"previewModal"}
                    open={true}
                    handleClose={this.handleCloseModal}
                    content={<ContentPreviewModal2 files={[fileView]} keyFile={0}/>}
                    saveButton={false}
                    cancelButton={false}
                />}
            </div>
        )
    }
}

export default compose(
    withStyles(styles),
    withTranslation(),
    withRouter
)(ReadShareDocuments);
